import c from '@/styles/Checkbox';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';
import { getPropStylesFactory } from 'lib/utils/getPropStylesFactory';
import { CheckboxInputComponent } from './Checkbox.Input';
import { CheckboxLabelComponent } from './Checkbox.Label';

export interface CheckboxProps extends ComponentProps<'div'> {
  colors?: ClassNameProp<'default' | 'alternative'>;
  size?: ClassNameProp<'default' | 'alternative'>;
  variant?: ClassNameProp<'default' | 'alternative'>;
}

const CheckboxComponent: Component<CheckboxProps> = ({ children, className, colors, size, variant, ...props }) => {
  const getPropStyles = getPropStylesFactory(c);

  const colorsClassName = getPropStyles('colors', colors ?? variant, 'default');
  const sizeClassName = getPropStyles('size', size ?? variant, 'default');
  const variantClassName = getPropStyles('variant', variant, 'default');
  const componentClassName = cn(sizeClassName, colorsClassName, variantClassName, className);

  return (
    <div className={componentClassName} {...props}>
      {children}
    </div>
  );
};

export const Checkbox = Object.assign(CheckboxComponent, {
  Input: CheckboxInputComponent,
  Label: CheckboxLabelComponent,
});
